import { DialogSize, useDialog } from '@ics-portal/guardian';
import { type ComponentSourceRaw } from '@gql/graphql';
import { ExternalSourcesContent } from './ExternalSourcesContent';

interface UseExternalSourcesDialogResult {
    openExternalSourcesDialog: (sources: ComponentSourceRaw[]) => void;
}

export function useExternalSourcesDialog(): UseExternalSourcesDialogResult {
    const { modal } = useDialog();

    function openExternalSourcesDialog(sources: ComponentSourceRaw[]): void {
        modal({
            title: 'External sources',
            size: DialogSize.md,
            content: <ExternalSourcesContent sources={sources} />,
        });
    }

    return { openExternalSourcesDialog };
}
